import FriSelection from "./FriSelection";
import Settings from "../../components/settings/Settings";

export default class Tipkovnica {
    kombs = [];
    kombarr = [];

    constructor(req) {
        this.req=req;
        this.getCombosFromServer();
    }

    Kombo(shift, alt, ctrlkey, key) {
        this.shift = shift;
        this.alt = alt;
        this.ctrlKey = ctrlkey;
        this.key = key;
    }

    async getCombosFromServer() {
        const response = await fetch(Settings.load("server")+'/allKbd', {method: 'POST'});
        this.kombs = await response.json();
    }

    shiftAdjust(key) {
        switch (key) {
            case "!":
                return "1";
            case "\"":
                return "2";
            case "#":
                return "3";
            case "$":
                return "4";
            case "%":
                return "5";
            case "&":
                return "6";
            case "/":
                return "7";
            case "(":
                return "8";
            case ")":
                return "9";
            case "=":
                return "0";
            case "?":
                return "'";
            case "*":
                return "+";
            default:
                return key;
        }
    }

    komb1 = new this.Kombo(false, false, false, "");

    handleKbdDown(zEvent) {

        if (zEvent.key === "Shift")
            this.komb1.shift = true;
        else if (zEvent.key === "Alt" || zEvent.key === "Meta")
            this.komb1.alt = true;
        else if (zEvent.key === "Control")
            this.komb1.ctrlKey = true;
        else {
            this.komb1.key = this.shiftAdjust(zEvent.key);
            this.kombarr.push(this.komb1);
            this.processKomb(this.createkomb(this.kombarr), zEvent);
            this.komb1 = new this.Kombo(this.komb1.shift, this.komb1.alt, this.komb1.ctrlKey, "");
        }
    }

    handleKbdUp(zEvent) {
        if (zEvent.key === "Shift")
            this.komb1.shift = false;
        else if (zEvent.key === "Alt" || zEvent.key === "Meta")
            this.komb1.alt = false;
        else if (zEvent.key === "Control")
            this.komb1.ctrlKey = false;
    }

    createkomb(objcmb) {

        let ret = "";
        for (let z = 0; z < objcmb.length; z++) {
            if (objcmb[z].alt)
                ret += "alt+";
            if (objcmb[z].shift)
                ret += "shift+";
            if (objcmb[z].ctrlKey)
                ret += "ctrl+";
            ret += objcmb[z].key;
            if (z !== objcmb.length - 1)
                ret += "+"
        }
        return ret.toLowerCase();
    }

    processKomb(komb, zEvent) {
        let reset = true;
        if (komb.startsWith("alt+") || komb.startsWith("shift+") || komb.startsWith("ctrl+")) {
            for (let k = 0; k < this.kombs.length; k++) {
                if (this.kombs[k].komb === komb) {
                    this.insertToVnos(this.kombs[k].key, zEvent);
                    zEvent.preventDefault();
                    break;
                }
                else if (this.kombs[k].komb.startsWith(komb)) {
                    zEvent.preventDefault();
                    reset = false;
                    break;
                }
            }
        }
        if (reset) {
            this.kombarr = [];
        }
    }

    insertToVnos(text, event) {
        let frisel = new FriSelection(event.target);
        frisel.replaceSelectedText(text);
        this.req(event.target);
    }
}


// WEBPACK FOOTER //
// ./src/scripts/kbd/Tipkovnica.js